// extracted by mini-css-extract-plugin
export default {"container":"chatInput_container__eobFm","input":"chatInput_input__M4bSM"};